export const stripCardNumber = (value) => (value || '').replace(/\D/g, '');

export const formatCardNumber = (value) => {
  const digits = stripCardNumber(value);
  return digits.replace(/(\d{4})(?=\d)/g, '$1 ').trim();
};

export const maskCardNumber = (value) => {
  const digits = stripCardNumber(value);
  if (!digits) return '';

  const lastFour = digits.slice(-4);
  const maskedGroups = Math.max(Math.ceil(digits.length / 4) - 1, 0);
  const masked = Array.from({ length: maskedGroups }, () => '****').join(' ');

  return masked ? `${masked} ${lastFour}` : lastFour;
};
